import { logService } from './log-service'
import { localStorageService, sessionStorageService } from './storage-service'

const clientVersion = process.env.REACT_APP_VERSION

export const appService = {
  checkVersion(serverVersion?: string | null) {
    const lastReloadTime = sessionStorageService.getLastReloadTime()
    const currentTime = Date.now()

    if (lastReloadTime && currentTime - lastReloadTime < 25000) {
      console.info('Checked version recently, skipping check.')
      return
    }

    sessionStorageService.setLastReloadTime(currentTime)

    setTimeout(() => {
      console.info('Version', { clientVersion, serverVersion })

      if (!serverVersion) return

      const prevVersion = localStorageService.getVersion()

      localStorageService.setVersion(serverVersion)

      logService.info('Checking version', { clientVersion, serverVersion, prevVersion })

      if (serverVersion !== process.env.REACT_APP_VERSION) {
        logService.info('New version available, refreshing site', { clientVersion, serverVersion, prevVersion })
        window.location.reload()
      } else {
        console.info('Version up to date')
      }
    }, 750)
  },
}
